import { useEffect, useState } from "react";
import { toast } from "sonner";
import { DeviceMobile, DownloadSimple, ShareNetwork } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export default function InstallAppCard() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); toast.success("Uygulama ana ekrana eklendi"); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", onPrompt); window.removeEventListener("appinstalled", onInstalled); };
  }, []);

  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setPrompt(null);
  };

  return (
    <div className="panel fade-up p-6" data-testid="install-app-card">
      <h3 className="flex items-center gap-2 font-display text-lg font-bold"><DeviceMobile size={18} /> Telefona Uygulama Olarak Ekle</h3>
      <p className="mt-1 text-xs text-muted-foreground">bizimcari... telefonunuzun ana ekranına simge olarak eklenebilir; tam ekran, hızlı ve uygulama gibi açılır.</p>
      <div className="mt-4 text-sm">
        {installed ? (
          <p className="text-teal-700" data-testid="install-app-installed">Uygulama olarak kullanıyorsunuz.</p>
        ) : prompt ? (
          <Button onClick={install} className="rounded-[4px]" data-testid="install-app-button"><DownloadSimple /> Ana ekrana ekle</Button>
        ) : isIos() ? (
          <p className="flex items-center gap-2" data-testid="install-app-ios-hint">Safari'de <ShareNetwork size={16} /> <b>Paylaş</b> → <b>Ana Ekrana Ekle</b> seçeneğine dokunun.</p>
        ) : (
          <p data-testid="install-app-hint">Tarayıcı menüsünden (⋮) <b>Uygulamayı yükle</b> veya <b>Ana ekrana ekle</b> seçeneğini kullanın.</p>
        )}
      </div>
    </div>
  );
}
